import React from "react";

import { CampoEstatico, Card, Col, Row } from "@intechprev/componentes-web";
import { PlanoVinculadoEntidade, ProcessoBeneficioEntidade } from "../../../../entidades";

interface IProps {
  processosBeneficio: ProcessoBeneficioEntidade | null;
  plano: PlanoVinculadoEntidade | null;
}

export const SaldoAtual: React.FC<IProps> = ({
  processosBeneficio,
  plano
}) => {


  if (processosBeneficio !== null && processosBeneficio !== undefined && processosBeneficio.SALDO_ATUAL > 0) {
    return (
      <Row>
        <Col>
          <Card titulo={"Saldo de Conta Aplicável Atual - SCAA (em cotas) "}>
            <CampoEstatico valor={processosBeneficio.SALDO_ATUAL} />
          </Card>
        </Col>
        <Col>
          <Card titulo={"Renda - % SCAA"}>
            {processosBeneficio.VL_PARCELA_MENSAL}%
          </Card>
        </Col>
        <Col>
          <Card titulo={"Provável Encerramento do Benefício"}>
            {processosBeneficio.DT_APOSENTADORIA}
          </Card>
        </Col>
        {plano.CD_PLANO !== "0001" &&
          <Col>
            <Card titulo={"Regime de Tributação"}>
              {plano.TIPO_IRRF === "2" ? "Regressivo" : "Progressivo"}
            </Card>
          </Col>
        }
      </Row>
    )
  }

  return (
    null
  );
}